import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/link';
import linkSizes from 'components/link/link-sizes';

const TableOfContentBlock = ({ heading, links }) => {
  return (
    <div className="table-of-content-block">
      <div className="table-of-content-block__container">
        <div className="table-of-content-block__content">
          {heading && (
            <div className="table-of-content-block__heading-col">
              <h2 className="table-of-content-block__heading">{heading}</h2>
            </div>
          )}
          {links && links.length > 0 ? (
            <div className="table-of-content-block__list-col">
              <ul className="table-of-content-block__list">
                {links.map((item, i) => (
                  <li key={i} className="table-of-content-block__list-item">
                    <Link
                      {...item}
                      size={linkSizes.large}
                      iconName="arrow-right"
                    />
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

TableOfContentBlock.propTypes = {
  heading: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.shape(Link.propTypes)),
};

export default TableOfContentBlock;
